(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33],{

/***/ 69225:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/[slug]",
      function () {
        return __webpack_require__(80808);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28889);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62822);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50998);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46869);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(95757);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var routes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68711);
/* harmony import */ var utils_routes_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24039);
/* harmony import */ var components_navigation_Link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18780);







var CollectionList = function(param) {
    var collection = param.collection, isAboveFold = param.isAboveFold, removePaddingLeft = param.removePaddingLeft, onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ml: removePaddingLeft ? -4 : 0,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            children: collection.map(function(collection) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        button: true,
                        component: components_navigation_Link__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .C,
                        onClick: function() {
                            onClick === null || onClick === void 0 ? void 0 : onClick(collection);
                        },
                        href: (0,utils_routes_utils__WEBPACK_IMPORTED_MODULE_7__/* .generatePath */ .G)(routes__WEBPACK_IMPORTED_MODULE_8__/* .Routes.collection */ .Z.collection, {
                            slug: collection.slugName
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: collection.icon,
                                    height: 24,
                                    width: 24,
                                    priority: isAboveFold,
                                    alt: "".concat(collection.name, " icon")
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                children: collection.name
                            })
                        ]
                    })
                }, collection.id);
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionList);


/***/ }),

/***/ 17709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ DurationMs; }
/* harmony export */ });
/* unused harmony export Duration */
var ONE_MINUTE_MS = 60000;
var DurationMs;
(function(DurationMs) {
    DurationMs[DurationMs["THIRTY_SEC"] = ONE_MINUTE_MS / 2] = "THIRTY_SEC";
    DurationMs[DurationMs["MINUTE"] = ONE_MINUTE_MS] = "MINUTE";
    DurationMs[DurationMs["FIVE_MIN"] = 5 * ONE_MINUTE_MS] = "FIVE_MIN";
    DurationMs[DurationMs["FIFTEEN_MIN"] = 15 * ONE_MINUTE_MS] = "FIFTEEN_MIN";
    DurationMs[DurationMs["THIRTY_MIN"] = 30 * ONE_MINUTE_MS] = "THIRTY_MIN";
    DurationMs[DurationMs["FORTY_FIVE_MIN"] = 45 * ONE_MINUTE_MS] = "FORTY_FIVE_MIN";
    DurationMs[DurationMs["ONE_HOUR"] = 60 * ONE_MINUTE_MS] = "ONE_HOUR";
    DurationMs[DurationMs["FOREVER"] = Infinity] = "FOREVER";
})(DurationMs || (DurationMs = {}));
var ONE_MINUTE = 60;
var Duration;
(function(Duration) {
    Duration[Duration["THIRTY_SEC"] = ONE_MINUTE / 2] = "THIRTY_SEC";
    Duration[Duration["MINUTE"] = ONE_MINUTE] = "MINUTE";
    Duration[Duration["FIVE_MIN"] = 5 * ONE_MINUTE] = "FIVE_MIN";
    Duration[Duration["FIFTEEN_MIN"] = 15 * ONE_MINUTE] = "FIFTEEN_MIN";
    Duration[Duration["THIRTY_MIN"] = 30 * ONE_MINUTE] = "THIRTY_MIN";
    Duration[Duration["FORTY_FIVE_MIN"] = 45 * ONE_MINUTE] = "FORTY_FIVE_MIN";
    Duration[Duration["ONE_HOUR"] = 60 * ONE_MINUTE] = "ONE_HOUR";
    Duration[Duration["FOREVER"] = Infinity] = "FOREVER";
})(Duration || (Duration = {}));


/***/ }),

/***/ 80808:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DynamicCollectionType": function() { return /* binding */ DynamicCollectionType; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(28889);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./src/hooks/search/useSimpleSearch.ts + 1 modules
var useSimpleSearch = __webpack_require__(1470);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/queries/collections/useCollections.ts
var useCollections = __webpack_require__(10573);
// EXTERNAL MODULE: ./src/queries/search/useSearch.ts
var useSearch = __webpack_require__(70694);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/routes.ts
var routes = __webpack_require__(68711);
// EXTERNAL MODULE: ./src/queries/collections/useNew.ts
var useNew = __webpack_require__(47775);
// EXTERNAL MODULE: ./src/queries/collections/useWinRealPrizes.ts
var useWinRealPrizes = __webpack_require__(98133);
;// CONCATENATED MODULE: ./src/hooks/collections/useDynamicCollections.ts


var useDynamicCollections = function(slug) {
    var collections = (0,useCollections/* useCollections */.b)({
        enabled: slug === DynamicCollectionType.Collections
    }).collections;
    var newCollection = (0,useNew/* useNew */.p)(undefined, {
        enabled: slug === DynamicCollectionType.NewGames
    }).newCollection;
    // const { trendingNow } = useTrendingNow({
    //   enabled: slug === DynamicCollectionType.TrendingNow,
    // });
    var winRealPrizes = (0,useWinRealPrizes/* useWinRealPrizes */.o)(undefined, {
        enabled: slug === DynamicCollectionType.WinRealPrizes
    }).winRealPrizes;
    var matchDynamicCollection = function(slug) {
        switch(slug){
            case DynamicCollectionType.NewGames:
                return newCollection;
            // case DynamicCollectionType.TrendingNow:
            //   return trendingNow;
            case DynamicCollectionType.WinRealPrizes:
                return winRealPrizes;
            default:
                return [];
        }
    };
    return {
        isCollection: slug === DynamicCollectionType.Collections,
        collections: collections !== null && collections !== void 0 ? collections : [],
        games: matchDynamicCollection(slug)
    };
};

// EXTERNAL MODULE: ./src/components/@common/CollectionList/CollectionList.tsx
var CollectionList = __webpack_require__(2283);
// EXTERNAL MODULE: ./src/components/@common/Search/SearchEmptyState/SearchEmptyState.tsx
var SearchEmptyState = __webpack_require__(78670);
// EXTERNAL MODULE: ./src/components/@game-detail/Section/GameSection.tsx + 2 modules
var GameSection = __webpack_require__(65943);
;// CONCATENATED MODULE: ./src/components/@collections/DynamicCollection/DynamicCollection.tsx







var DynamicCollection = function(param) {
    var slug = param.slug, searchData = param.searchData, term = param.term, onClear = param.onClear;
    var ref = useDynamicCollections(slug), collections = ref.collections, games = ref.games, isCollection = ref.isCollection;
    if (!!term && (isCollection && !searchData.collections.length || !isCollection && !searchData.games.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mt: 10,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchEmptyState/* default */.Z, {
                value: term,
                onClear: onClear
            })
        });
    }
    if (isCollection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionList/* default */.Z, {
            collection: !!term ? searchData.collections : collections,
            removePaddingLeft: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GameSection/* default */.Z, {
        id: "games",
        data: !!term ? searchData.games : games,
        variant: "detail",
        imagesAboveFold: true,
        disablePadding: true
    });
};
/* harmony default export */ var DynamicCollection_DynamicCollection = (DynamicCollection);

// EXTERNAL MODULE: ./src/queries/collections/useCollectionById.ts
var useCollectionById = __webpack_require__(49874);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
;// CONCATENATED MODULE: ./src/components/@collections/StaticCollection/StaticCollection.tsx







var StaticCollection = function(param) {
    var id = param.id, searchData = param.searchData, term = param.term, onClear = param.onClear;
    var ref = (0,useCollectionById/* useCollectionById */.d)(id), collection = ref.collection, fetchNextPage = ref.fetchNextPage, hasNextPage = ref.hasNextPage;
    if (!!term && !searchData.games.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            mt: 10,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchEmptyState/* default */.Z, {
                value: term,
                onClear: onClear
            })
        });
    }
    if (!!term && !!searchData.games.length) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GameSection/* default */.Z, {
            id: "games",
            data: searchData.games,
            variant: "detail",
            imagesAboveFold: true,
            disablePadding: true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
        hasMore: hasNextPage,
        next: fetchNextPage,
        dataLength: collection.length,
        loader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            justifyContent: "center",
            py: 6,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 24
            })
        }),
        style: {
            overflow: "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GameSection/* default */.Z, {
            id: "games",
            data: collection,
            variant: "detail",
            imagesAboveFold: true,
            disablePadding: true
        })
    });
};
/* harmony default export */ var StaticCollection_StaticCollection = (StaticCollection);

// EXTERNAL MODULE: ./src/components/@common/Background/Background.tsx
var Background = __webpack_require__(68224);
// EXTERNAL MODULE: ./src/components/@common/Search/SearchInput/SearchInput.tsx
var SearchInput = __webpack_require__(38825);
// EXTERNAL MODULE: ./src/components/@home/NotLoggedInCta/NotLoggedInCta.tsx
var NotLoggedInCta = __webpack_require__(14357);
// EXTERNAL MODULE: ./src/components/@layout/NavigationLayout/NavigationLayout.tsx + 12 modules
var NavigationLayout = __webpack_require__(18039);
// EXTERNAL MODULE: ./src/components/@navigation/HeaderSimple/HeaderSimple.tsx
var HeaderSimple = __webpack_require__(17854);
;// CONCATENATED MODULE: ./src/pages/collection/[slug].tsx
















var __N_SSG = true;
var DynamicCollectionType;
(function(DynamicCollectionType) {
    DynamicCollectionType["NewGames"] = "new-games";
    DynamicCollectionType["Collections"] = "collections";
    DynamicCollectionType["WinRealPrizes"] = "win-real-prizes";
})(DynamicCollectionType || (DynamicCollectionType = {}));
//Static collection can be changed at all times by Newcom
//Dynamic collection is a fixed collection filled with an algorithm (ex: new-games)
//atm for dynamic collection we only need to support new-games, i've added the other ones in comments for the future.
var Collection = function(param) {
    var slug = param.slug;
    var ref = (0,router.useRouter)(), push = ref.push, isFallback = ref.isFallback;
    var intl = (0,useIntl/* default */.Z)();
    var collections = (0,useCollections/* useCollections */.b)().collections;
    var staticMatch = collections.find(function(collection) {
        return collection.slugName === slug;
    });
    var ref1 = (0,useSimpleSearch/* useSimpleSearch */.G)(), currentValue = ref1.currentValue, debouncedValue = ref1.debouncedValue, searchChange = ref1.searchChange, searchClear = ref1.searchClear;
    var ref2 = (0,useSearch/* useSearch */.R)(debouncedValue, staticMatch === null || staticMatch === void 0 ? void 0 : staticMatch.id), searchData = ref2.searchData, isLoading = ref2.isLoading;
    if (isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 24
            })
        });
    }
    var dynamicTypesArray = Object.values(DynamicCollectionType);
    var isDynamic = dynamicTypesArray.includes(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: isDynamic ? intl.formatMessage({
                    id: "collection.title.".concat(slug)
                }) : intl.formatMessage({
                    id: "seo.title.collections.slug"
                }, {
                    collection: staticMatch === null || staticMatch === void 0 ? void 0 : staticMatch.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Background/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "main",
                height: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    maxWidth: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSimple/* default */.Z, {
                            onBackClick: function() {
                                return push(routes/* Routes.home */.Z.home);
                            },
                            rightItems: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                                value: currentValue,
                                onChange: searchChange,
                                onClear: searchClear,
                                fullWidth: true
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mt: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h4",
                                color: "textPrimary",
                                children: isDynamic ? /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "collection.title.".concat(slug)
                                }) : staticMatch === null || staticMatch === void 0 ? void 0 : staticMatch.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotLoggedInCta/* default */.ZP, {
                            description: intl.formatMessage({
                                id: "collection.account.intro.body"
                            }),
                            pt: 2
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            mb: 6,
                            children: [
                                isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    mt: 16,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        size: 24
                                    })
                                }),
                                !isLoading && dynamicTypesArray.includes(slug) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicCollection_DynamicCollection, {
                                    slug: slug,
                                    term: debouncedValue,
                                    searchData: searchData,
                                    onClear: searchClear
                                }),
                                !isLoading && staticMatch && !dynamicTypesArray.includes(slug) && /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticCollection_StaticCollection, {
                                    id: staticMatch === null || staticMatch === void 0 ? void 0 : staticMatch.id,
                                    term: debouncedValue,
                                    searchData: searchData,
                                    onClear: searchClear
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
// @ts-ignore
Collection.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationLayout/* default */.Z, {
        headerVariant: "none",
        children: page
    });
};
/* harmony default export */ var _slug_ = (Collection);


/***/ }),

/***/ 49874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useCollectionById; }
/* harmony export */ });
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58416);



var useCollectionById = function(id) {
    var ref, ref1;
    var fetchCollection = function(params) {
        var cursor = undefined;
        if (params.pageParam) cursor = params.pageParam.split("?cursor=")[1];
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getGameCollection */ .Z.getGameCollection(id, cursor);
    };
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useInfiniteQuery)(queries__WEBPACK_IMPORTED_MODULE_2__/* .QueryKeys.collectionbyid.all */ .i.collectionbyid.all(id), fetchCollection, {
        enabled: !!id.length,
        getNextPageParam: function(lastPage) {
            return lastPage.loadMoreUrl;
        }
    }), data = ref2.data, isLoading = ref2.isLoading, fetchNextPage = ref2.fetchNextPage, hasNextPage = ref2.hasNextPage, isFetchingNextPage = ref2.isFetchingNextPage;
    return {
        isLoading: isLoading,
        isFetchingNextPage: isFetchingNextPage,
        fetchNextPage: fetchNextPage,
        hasNextPage: hasNextPage !== null && hasNextPage !== void 0 ? hasNextPage : false,
        collection: data ? (ref1 = data === null || data === void 0 ? void 0 : (ref = data.pages) === null || ref === void 0 ? void 0 : ref.map(function(page) {
            return page.items;
        })) === null || ref1 === void 0 ? void 0 : ref1.filter(function(i) {
            return i !== undefined;
        }).flat(1) : []
    };
};


/***/ }),

/***/ 10573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useCollections; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58416);




var useCollections = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_1__/* .QueryKeys.collections.all */ .i.collections.all(), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getCollections */ .Z.getCollections();
    }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, options)), data = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        collections: data !== null && data !== void 0 ? data : []
    };
};


/***/ }),

/***/ 47775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ useNew; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var constants_cache__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17709);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58416);






var useNew = function(limit) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_1__/* .QueryKeys["new"].all */ .i["new"].all(limit), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getNewCollection */ .Z.getNewCollection(limit);
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
        cacheTime: constants_cache__WEBPACK_IMPORTED_MODULE_5__/* .DurationMs.FIVE_MIN */ .P.FIVE_MIN,
        staleTime: constants_cache__WEBPACK_IMPORTED_MODULE_5__/* .DurationMs.FIVE_MIN */ .P.FIVE_MIN
    })), data = ref.data, isLoading = ref.isLoading, isError = ref.isError, refetch = ref.refetch;
    return {
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
        newCollection: data !== null && data !== void 0 ? data : []
    };
};


/***/ }),

/***/ 98133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useWinRealPrizes; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var constants_cache__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17709);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58416);






var useWinRealPrizes = function(limit) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)(queries__WEBPACK_IMPORTED_MODULE_1__/* .QueryKeys.winRealPrizes.all */ .i.winRealPrizes.all(limit), function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getWinRealPrizesCollection */ .Z.getWinRealPrizesCollection(limit);
    }, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
        cacheTime: constants_cache__WEBPACK_IMPORTED_MODULE_5__/* .DurationMs.FIVE_MIN */ .P.FIVE_MIN,
        staleTime: constants_cache__WEBPACK_IMPORTED_MODULE_5__/* .DurationMs.FIVE_MIN */ .P.FIVE_MIN
    })), data = ref.data, isLoading = ref.isLoading, isError = ref.isError, refetch = ref.refetch;
    return {
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
        winRealPrizes: data !== null && data !== void 0 ? data : []
    };
};


/***/ }),

/***/ 70694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useSearch; }
/* harmony export */ });
/* harmony import */ var queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11777);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88767);
/* harmony import */ var services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58416);



var useSearch = function(term, collectionId) {
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_0__.useQuery)([
        queries__WEBPACK_IMPORTED_MODULE_1__/* .QueryKeys.search.all */ .i.search.all(term, collectionId)
    ], function() {
        return services_api_ApiService__WEBPACK_IMPORTED_MODULE_2__/* ["default"].search */ .Z.search(term, collectionId);
    }, {
        enabled: !!term
    }), searchData = ref.data, isLoading = ref.isLoading;
    return {
        isLoading: isLoading,
        searchData: searchData !== null && searchData !== void 0 ? searchData : {
            games: [],
            collections: []
        }
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9282,1743,7594,8054,4207,8039,8926,9774,2888,179], function() { return __webpack_exec__(69225); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);